/**
 *
 * Please note:
 * This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit this file manually.
 *
 */

@file:Suppress(
    "ArrayInDataClass",
    "EnumEntryName",
    "RemoveRedundantQualifierName",
    "UnusedImport"
)

package org.openapitools.client.models


import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

/**
 * 
 *
 * @param id 
 * @param type 
 * @param `data` 
 * @param tableData 
 * @param boardData 
 * @param columns 
 */
@Serializable

data class SaveLoopDataInDb (

    @SerialName(value = "id") val id: kotlin.String? = null,

    @SerialName(value = "type") var type: kotlin.String? = null,

    @SerialName(value = "data") var `data`: kotlin.String? = null,

    @SerialName(value = "tableData") val tableData: MutableList<MutableList<kotlin.String>>? = null,

    @SerialName(value = "boardData") val boardData: MutableList<TaskItem>? = null,

    @SerialName(value = "columns") val columns: MutableList<TaskStatusDetailsResponse>? = null

)

